import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
	selector: "app-breadcrumb",
	templateUrl: "./breadcrumb.component.html"
})
export class BreadcrumbComponent {
	@Input() breadcrumb = [];

	constructor(private router: Router) {}

	goToRoute(link) {
		if (link) {
			this.router.navigate([link]);
		}
	}
}
